import { render } from "./DeskBooking.vue?vue&type=template&id=8656899c&scoped=true&ts=true"
import script from "./DeskBooking.vue?vue&type=script&lang=ts"
export * from "./DeskBooking.vue?vue&type=script&lang=ts"

import "./DeskBooking.vue?vue&type=style&index=0&id=8656899c&lang=scss&scoped=true"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8656899c"],['__file',"src/views/modules/deskbookig/views/DeskBooking.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8656899c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8656899c', __exports__)) {
    api.reload('8656899c', __exports__)
  }
  
  module.hot.accept("./DeskBooking.vue?vue&type=template&id=8656899c&scoped=true&ts=true", () => {
    api.rerender('8656899c', render)
  })

}


export default __exports__